/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const HoldingAccountTypeFormatter = (cellContent, row, rowIndex) => {
  const { holdingAccountType } = row;

  return (
    <>
      <div className="d-flex align-items-center">
        {holdingAccountType ? holdingAccountType : `-`}
      </div>
      <> </>
    </>
  );
};
